import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useStyles } from './styles';
import TableToolbar from './components/TableToolbar/TableToolbar';
import CategoriesTable from './components/CategoriesTable/CategoriesTable';
import Toast from '../../components/Toast/Toast';
import { useCategoriesContext } from '../../context/CategoriesContext';
import CategoriesManager from './components/CategoriesManager/CategoriesManager';
import MoveToCategoryManager from './components/MoveToCategoryManager/MoveToCategoryManager';
import Loader from './components/Loader/Loader';

export default function CategoriesManagement() {
  const classes = useStyles();
  const { foodMenu, selectedIds, loading } = useCategoriesContext();
  const [openManageModal, setOpenManageModal] = useState<boolean>(false);
  const [openMoveModal, setOpenMoveModal] = useState<boolean>(false);
  const [openToast, setOpenToast] = useState(false);
  const [toast, setToast] = useState<{ type: 'error' | 'success'; content: string }>({
    type: 'success',
    content: '',
  });

  const handleOpenManageModal = () => setOpenManageModal(true);
  const handleCloseManageModal = () => setOpenManageModal(false);
  const handleOpenMoveModal = () => setOpenMoveModal(true);
  const handleCloseMoveModal = () => setOpenMoveModal(false);

  return (
    <Box component="main" className={classes.Dashboard}>
      <TableToolbar onOpenMoveModal={handleOpenMoveModal} onOpenManageModal={handleOpenManageModal} />
      {loading ? <Loader /> : <CategoriesTable />}
      <CategoriesManager open={openManageModal} handleClose={handleCloseManageModal} categories={foodMenu.categories} setOpenToast={setOpenToast} setToast={setToast} />
      <MoveToCategoryManager open={openMoveModal} handleClose={handleCloseMoveModal} categories={foodMenu.categories} selectedFoodIds={selectedIds} setOpenToast={setOpenToast} setToast={setToast} onOpenManageModal={handleOpenManageModal} />
      <Toast
        content={toast.content}
        variant={toast.type}
        open={openToast}
        onClose={() => {
          setOpenToast(false);
        }}
      />
    </Box>
  );
}
